import ApiBase from './ApiBase'

export default class ApiObject extends ApiBase {

	constructor () {
		super()
		this.data = {}
	}

	isEmpty () {
		for (let key in this.data) {
			return false
		}
		return true
	}

	hasData () {
		for (let key in this.data) {
			return true
		}
		return false
	}
}



// WEBPACK FOOTER //
// ./src/classes/api/ApiObject.js